import { ReactElement } from 'react';
import MaterialOwner from '../../../../../../../../common/material/material-long/template/components/material-owner/material-owner';
import MaterialCardRating from '../../../../components/material-card-rating/material-card-rating';
import MaterialTitle from '../../../../components/material-title/material-title';
import './right-aside.scss';

type RightAsideProps = { item: Material; index: number; internalPath?: string };

const RightAside = ({ item, index, internalPath }: RightAsideProps): ReactElement => (
    <aside className='right-aside'>
        <MaterialTitle item={item} index={index} internalPath={internalPath} />

        <MaterialCardRating item={item} />

        <MaterialOwner item={item} />
    </aside>
);

export default RightAside;
